module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "section section-white"
  }, [_c('div', {
    staticClass: "section-body"
  }, [_c('el-form', {
    ref: "form",
    staticClass: "demo-ruleForm",
    attrs: {
      "model": _vm.form,
      "label-width": "100px",
      "label-position": "right"
    }
  }, [(!_vm.form.id) ? _c('div', {
    staticClass: "content-center content-bottom-padded"
  }, [_c('el-radio-group', {
    on: {
      "change": _vm.handleTypeChange
    },
    model: {
      value: (_vm.form.tem_type),
      callback: function($$v) {
        _vm.$set(_vm.form, "tem_type", $$v)
      },
      expression: "form.tem_type"
    }
  }, [_c('el-radio-button', {
    attrs: {
      "label": "basic_entry"
    }
  }, [_vm._v("基础录入")]), _vm._v(" "), _c('el-radio-button', {
    attrs: {
      "label": "ask_answer_paper"
    }
  }, [_vm._v("问卷调查")])], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "标题",
      "prop": "tem_name",
      "rules": [{
        required: true,
        message: '请输入标题',
        trigger: 'blur'
      }]
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "maxlength": 30,
      "placeholder": "体测表单"
    },
    model: {
      value: (_vm.form.tem_name),
      callback: function($$v) {
        _vm.$set(_vm.form, "tem_name", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.tem_name"
    }
  })], 1)], 1), _vm._v(" "), (_vm.form.tem_type == 'ask_answer_paper') ? _c('el-form-item', {
    attrs: {
      "label": "表单风格",
      "prop": "form_style",
      "rules": [{
        required: true,
        message: '请输入标题',
        trigger: 'blur'
      }]
    }
  }, [_c('el-row', {
    attrs: {
      "gutter": 20
    }
  }, [_c('el-col', {
    attrs: {
      "span": 5
    }
  }, [_c('el-radio', {
    attrs: {
      "label": "single"
    },
    model: {
      value: (_vm.form.form_style),
      callback: function($$v) {
        _vm.$set(_vm.form, "form_style", $$v)
      },
      expression: "form.form_style"
    }
  }, [_vm._v("单页问卷(多项集合)")])], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [(_vm.form.form_style == 'single') ? _c('el-alert', {
    attrs: {
      "show-icon": "",
      "closable": false,
      "title": "单页问卷方式不支持图片显示",
      "type": "warning"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.form.form_style == 'multiple') ? _c('el-alert', {
    attrs: {
      "show-icon": "",
      "closable": false,
      "title": "多页问卷方式提供图片显示",
      "type": "warning"
    }
  }) : _vm._e()], 1)], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.tem_type == 'ask_answer_paper' && _vm.form.form_style == 'single') ? _c('el-form-item', {
    attrs: {
      "label": "头部文字"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": 500,
      "placeholder": "体测表单"
    },
    model: {
      value: (_vm.form.header_title),
      callback: function($$v) {
        _vm.$set(_vm.form, "header_title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.header_title"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), (_vm.form.tem_type == 'ask_answer_paper' && _vm.form.form_style == 'single') ? _c('el-form-item', {
    attrs: {
      "label": "底部文字"
    }
  }, [_c('el-col', {
    attrs: {
      "span": 20
    }
  }, [_c('el-input', {
    attrs: {
      "type": "textarea",
      "maxlength": 500,
      "placeholder": "体测表单"
    },
    model: {
      value: (_vm.form.bottom_title),
      callback: function($$v) {
        _vm.$set(_vm.form, "bottom_title", (typeof $$v === 'string' ? $$v.trim() : $$v))
      },
      expression: "form.bottom_title"
    }
  })], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "表单内容",
      "prop": "content",
      "rules": [{
        required: true,
        message: '请选择表单内容',
        trigger: 'change'
      }]
    }
  }, _vm._l((_vm.form.content), function(item, index) {
    return _c('el-row', {
      key: index,
      attrs: {
        "gutter": 2
      }
    }, [_c('el-col', {
      attrs: {
        "span": 18
      }
    }, [_c('el-card', {
      staticClass: "box-card"
    }, [_c('div', {
      staticClass: "clearfix",
      attrs: {
        "slot": "header"
      },
      slot: "header"
    }, [(_vm.form.tem_type == 'ask_answer_paper') ? [_c('span', [_vm._v("区块一标题:")]), _c('el-input', {
      staticStyle: {
        "width": "200px"
      },
      attrs: {
        "placeholder": "区块标题",
        "size": "mini"
      },
      model: {
        value: (item.title),
        callback: function($$v) {
          _vm.$set(item, "title", $$v)
        },
        expression: "item.title"
      }
    }), _vm._v(" "), _c('span', [_vm._v("排序:")]), _c('el-input', {
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "size": "mini"
      },
      model: {
        value: (item.sort),
        callback: function($$v) {
          _vm.$set(item, "sort", $$v)
        },
        expression: "item.sort"
      }
    })] : _vm._e(), _vm._v(" "), _c('el-button', {
      staticStyle: {
        "float": "right",
        "padding": "3px 0"
      },
      attrs: {
        "type": "text"
      },
      on: {
        "click": function($event) {
          return _vm.checkContent(index)
        }
      }
    }, [_vm._v("选择表单内容")])], 2), _vm._v(" "), (item.formdata.length > 0) ? _c('el-col', [_c('el-table', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": item.formdata
      }
    }, [_c('el-table-column', {
      attrs: {
        "prop": "id",
        "label": "ID",
        "width": "40"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "field_title",
        "label": "标题",
        "width": "100"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "sort",
        "label": "排序",
        "width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-input', {
            attrs: {
              "width": "80",
              "size": "small"
            },
            model: {
              value: (scope.row.sort),
              callback: function($$v) {
                _vm.$set(scope.row, "sort", $$v)
              },
              expression: "scope.row.sort"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "sort",
        "label": "是否必填",
        "width": "100"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-checkbox', {
            attrs: {
              "checked": scope.row.is_required
            },
            model: {
              value: (scope.row.is_required),
              callback: function($$v) {
                _vm.$set(scope.row, "is_required", $$v)
              },
              expression: "scope.row.is_required"
            }
          })]
        }
      }], null, true)
    }), _vm._v(" "), (_vm.keyIndexIsShow) ? _c('el-table-column', {
      attrs: {
        "label": "设置关键指数(最多设置5个)"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return [_c('el-checkbox', {
            on: {
              "change": function($event) {
                return _vm.checkKeyIndex(scope.$index, scope.row)
              }
            },
            model: {
              value: (scope.row.key_index),
              callback: function($$v) {
                _vm.$set(scope.row, "key_index", $$v)
              },
              expression: "scope.row.key_index"
            }
          })]
        }
      }], null, true)
    }) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), (_vm.form.tem_type == 'ask_answer_paper') ? _c('el-col', {
      attrs: {
        "span": 2
      }
    }, [(index == 0) ? _c('el-button', {
      attrs: {
        "circle": "",
        "type": "primary"
      },
      on: {
        "click": _vm.addCard
      }
    }, [_vm._v("增")]) : _vm._e(), _vm._v(" "), (index != 0) ? _c('el-button', {
      attrs: {
        "circle": "",
        "type": "primary"
      },
      on: {
        "click": function($event) {
          return _vm.delCard(index)
        }
      }
    }, [_vm._v("删")]) : _vm._e()], 1) : _vm._e()], 1)
  }), 1), _vm._v(" "), (_vm.keyIndexIsShow && _vm.form.key_index.length > 0) ? _c('el-form-item', {
    attrs: {
      "label": "关键指数",
      "prop": "tem_name"
    }
  }, [_c('el-row', _vm._l((_vm.form.key_index), function(item, index) {
    return _c('el-col', {
      key: index,
      attrs: {
        "span": 4
      }
    }, [_c('div', [_vm._v(_vm._s(item.field_title))])])
  }), 1)], 1) : _vm._e(), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        return _vm.handleCancel.apply(null, arguments)
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submitAction
    }
  }, [_vm._v("保存")])], 1)], 1)], 1), _vm._v(" "), _c('SideBar', {
    attrs: {
      "visible": _vm.showElementList,
      "title": "选择表单元素",
      "width": "40"
    },
    on: {
      "update:visible": function($event) {
        _vm.showElementList = $event
      }
    }
  }, [_vm._t("default", function() {
    return [_c('el-row', {
      staticClass: "content-bottom-padded",
      attrs: {
        "gutter": 20
      }
    }, [_c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-select', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "请选择表单元素"
      },
      on: {
        "change": _vm.searchData
      },
      model: {
        value: (_vm.params.form_element),
        callback: function($$v) {
          _vm.$set(_vm.params, "form_element", $$v)
        },
        expression: "params.form_element"
      }
    }, _vm._l((_vm.formElement), function(item, key) {
      return _c('el-option', {
        key: item.value,
        attrs: {
          "label": item.name,
          "value": item.value
        }
      })
    }), 1)], 1), _vm._v(" "), _c('el-col', {
      attrs: {
        "span": 6
      }
    }, [_c('el-input', {
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "placeholder": "标题"
      },
      model: {
        value: (_vm.params.field_title),
        callback: function($$v) {
          _vm.$set(_vm.params, "field_title", $$v)
        },
        expression: "params.field_title"
      }
    }, [_c('el-button', {
      attrs: {
        "slot": "append",
        "icon": "el-icon-search"
      },
      on: {
        "click": _vm.searchData
      },
      slot: "append"
    })], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
      directives: [{
        name: "loading",
        rawName: "v-loading",
        value: (_vm.loading),
        expression: "loading"
      }],
      ref: "multipleTable",
      staticStyle: {
        "width": "100%"
      },
      attrs: {
        "data": _vm.ItemsList,
        "tooltip-effect": "dark",
        "row-key": _vm.getRowKeys,
        "select-on-indeterminate": false
      },
      on: {
        "select": _vm.handleSelectChange,
        "select-all": _vm.handleSelectAll
      }
    }, [_c('el-table-column', {
      attrs: {
        "type": "selection",
        "reserve-selection": true,
        "width": "50"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "id",
        "label": "ID",
        "width": "40"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "field_title",
        "label": "标题",
        "width": "150"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "prop": "form_element",
        "label": "元素",
        "width": "80"
      }
    }), _vm._v(" "), _c('el-table-column', {
      attrs: {
        "label": "选择项"
      },
      scopedSlots: _vm._u([{
        key: "default",
        fn: function(scope) {
          return _vm._l((scope.row.options), function(item, index) {
            return _c('span', {
              key: index
            }, [_vm._v(" " + _vm._s(item.value))])
          })
        }
      }])
    })], 1), _vm._v(" "), (_vm.total_count > _vm.params.pageSize) ? _c('div', {
      staticClass: "tr"
    }, [_c('el-pagination', {
      attrs: {
        "layout": "prev, pager, next",
        "total": _vm.total_count,
        "page-size": _vm.params.pageSize
      },
      on: {
        "current-change": _vm.handleCurrentChange
      }
    })], 1) : _vm._e(), _vm._v(" "), _c('span', {
      staticClass: "dialog-footer",
      attrs: {
        "slot": "footer"
      },
      slot: "footer"
    }, [_c('el-button', {
      attrs: {
        "type": "primary"
      },
      on: {
        "click": _vm.saveStoreAction
      }
    }, [_vm._v("确 定")])], 1)]
  })], 2)], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-4a6b627b", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4a6b627b"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/view/member/selfservice/formtemplateadd.vue
// module id = 2686
// module chunks = 0